<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-05-11 10:46:20
 * @LastEditors: 317473294@qq.com
 * @LastEditTime: 2024-09-29 22:29:45
 * @FilePath: /frontEnd/src/components/common/Header.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="header">
        <el-header>
            <!-- 教育平台-后台管理系统 -->
            <div class="title"></div>
            <div class="user-set">
                <i class="fa fa-user"></i>
                <span>{{ name }}</span>
     
                <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                        <i class="el-icon-setting set"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="about">关于</el-dropdown-item>
                        <el-dropdown-item command="theme">设置主题</el-dropdown-item>
                        <el-dropdown-item command="quit">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </el-header>
       <myTheme ref="openAndClose"></myTheme>
    </div>
</template>
<script>
import myTheme from '@/components/myTheme/myTheme.vue';
import { updataLog } from "@/api/loginLog.js"
import {getCurrentDateTime} from "@/utils/time.js"
import {tools} from "@/utils/tools.js"
export default {
    name: "Header",
    components:{
        myTheme
    },
    data() {
        return {
            name: "admin",
        }
    },
     created() {
        let userinfo=this.$store.state.userinfo
          if(typeof(userinfo)==='string'){
            this.name=JSON.parse(userinfo).username
            return
          }
        this.name=userinfo.username
        // //console.log("用户名=",this.name)

    },
    methods:{
       async handleCommand(command) {      
         
            switch(command){
            case 'theme':
                this.$refs.openAndClose.open()
                break
                case 'quit':
                await this.updataLoginLog()
              // localStorage.clear()清除上次登录用户名密码，若此时在地址栏输入项目网址相关页面，仍可以进入项目页面中，故加了下一行
			  localStorage.clear()
			  //加入该行后会清除缓存，当点击退出按钮后，会清除登录信息缓存
			  window.sessionStorage.clear()
               //退出后回到登陆页清空路由数据 location.reload()，如果不清空，则动态路由会不断添加，🈷越加越多
            //    this.$router.push('/login')
			  this.$router.replace({path:'/login'})
            //    location.reload()
			  
                break
            }
        // this.$message('click on item ' + command);
      },
      //更新系统退出时间
        //登录信息存储到数据库
        updataLoginLog(){
        let time=getCurrentDateTime()
        let logid=tools.localData("get")
        if(!logid){
            return
        }
        //console.log("获取日志logid",logid)
        let obj={
            quit_time:time,
            logid:logid
        }
       return new Promise((resolve, reject) => {
        updataLog(obj).then((res)=>{
             //console.log("更新日志信息",res)
             resolve(res)
        })
       }) 
      }
    }
}
</script>
<style lang="less" scoped>
@background: #d7dadf;

.header {
    background: @primaryColor;
    color: @primaryTextColor;
}

/deep/.el-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    line-height: 60px;

}

.title {
    font-size: 24px;
    font-weight: bold;
}

.user-set {
    display: flex !important;
    flex-direction: row;
    justify-content: center !important;
    align-items: center !important;
    font-size: 18px;
}

.user-set>span {
    margin-right: 20px;
    margin-left: 20px;
}
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
.set{
    cursor: pointer;
    font-size: 18px;
}</style>


// WEBPACK FOOTER //
// src/components/common/Header.vue